export const BROADCAST_MESSAGE_TYPES = Object.freeze(['Platform Update', 'Event', 'Maintenance', 'Community Update']);